import styles from './TopBanner.module.css';

const TopBanner = ({ bannerMessage }: any) => (
  <section id="webBanner">
    <div className={`${styles.container} webBanner`} dangerouslySetInnerHTML={{ __html: bannerMessage }} />
  </section>
);

export default TopBanner;
